import reducer from "./reducer";
export { default as IssuePermissions } from "./components";
export { default as issuePermissionsReducerName } from "./constants";
export default reducer;
